// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import './assets/css/common.css'
import './assets/css/theme.css'
import './assets/css/homepagestyle.css'
import './assets/css/homestyle.css'
// import './assets/js/modernizr.custom.86080.js'
import 'es6-promise/auto'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faHome,faBullseye,faCalendarCheck,faHandsHelping,faImages,faMobileAlt,faVideo,faImage } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faabacus } from '@fortawesome/free-solid-svg-icons'
library.add(faCoffee,faHome,faBullseye,faCalendarCheck,faHandsHelping,faImages,faMobileAlt,faVideo,faImage)


Vue.component('font-awesome-icon', FontAwesomeIcon)
// import './assets/js/hpcamain.js'
// import './assets/js/googleanalytics.js'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js